<script lang="ts">
  let currentScreen = $state(1);
  let selectedTags: string[] = $state(["가족여행"]);
  let budget = $state(1500);
  let duration = $state(7);
  let tripInput = $state("");
  let generating = $state(false);

  const recentTrips = [
    { id: 1, name: "도쿄 벚꽃 여행", startDate: "4월 10일", endDate: "4월 17일, 2026", distance: "1,200 km" },
    { id: 2, name: "발리 힐링 투어", startDate: "6월 1일", endDate: "6월 10일, 2026", distance: "5,300 km" },
    { id: 3, name: "제주도 드라이브", startDate: "10월 5일", endDate: "10월 12일, 2026", distance: "280 km" },
  ];

  const popularDestinations = [
    { name: "노르웨이 피요르드", trips: 15, image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=400&q=80", rating: 4.9 },
    { name: "교토 단풍 투어", trips: 23, image: "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=400&q=80", rating: 4.8 },
  ];

  const presetTags = ["가족여행", "예산여행", "럭셔리 경험", "해안 루트", "국립공원 투어", "미식 & 와인 투어"];

  const routeHighlights = [
    { from: "서울", to: "전주" },
    { from: "전주", to: "여수" },
    { from: "여수", to: "제주" },
  ];

  const itineraryDays = [
    { day: 1, title: "서울 출발 & 전주 도착", places: ["경복궁", "광화문", "KTX 탑승", "전주 한옥마을 체크인"] },
    { day: 2, title: "전주 한옥마을 탐방", places: ["비빔밥 조식", "전동성당", "교동 아트마켓", "막걸리 투어"] },
    { day: 3, title: "전주 → 여수 이동", places: ["오동도", "이순신광장", "돌산도 케이블카", "여수 야경"] },
    { day: 4, title: "여수 해상 투어", places: ["여수 엑스포 해양공원", "낭만포차", "항일암", "여수 수산시장"] },
    { day: 5, title: "여수 → 제주 이동", places: ["제주공항 도착", "렌터카 픽업", "성산일출봉", "우도 당일치기"] },
  ];

  let expandedDays = $state<Record<number, boolean>>({});

  function toggleTag(tag: string) {
    selectedTags = selectedTags.includes(tag)
      ? selectedTags.filter(t => t !== tag)
      : [...selectedTags, tag];
  }

  function toggleDay(day: number) {
    expandedDays = { ...expandedDays, [day]: !expandedDays[day] };
  }

  async function generateItinerary() {
    generating = true;
    await new Promise(r => setTimeout(r, 1800));
    generating = false;
    currentScreen = 3;
  }

  function formatBudget(val: number) {
    return new Intl.NumberFormat("ko-KR").format(val * 1000) + "원";
  }

  const navItems = [
    { screen: 1, label: "홈" },
    { screen: 2, label: "AI" },
    { screen: 3, label: "지도" },
    { screen: 0, label: "프로필" },
  ];
</script>

<!-- ── 외부 래퍼 (다크 배경) ── -->
<div class="min-h-screen bg-[#080808] flex flex-col items-center justify-start py-10 px-4">

  <!-- Demo 라벨 -->
  <div class="flex items-center gap-3 mb-7">
    <span class="bg-[#20b2aa] text-[#080808] text-[10px] font-black px-3 py-1 rounded-full tracking-[0.15em] uppercase">
      DEMO
    </span>
    <span class="text-white/40 text-xs tracking-wide">
      {currentScreen === 1 ? '화면 1/3 — 여행 홈' : currentScreen === 2 ? '화면 2/3 — AI 여행 빌더' : '화면 3/3 — 생성된 일정'}
    </span>
    <div class="flex gap-1.5 ml-1">
      {#each [1,2,3] as s}
        <button
          aria-label={`화면 ${s} 보기`}
          onclick={() => currentScreen = s}
          class="rounded-full transition-all duration-300 {currentScreen === s ? 'w-5 h-2 bg-[#20b2aa]' : 'w-2 h-2 bg-white/20 hover:bg-white/40'}"
        ></button>
      {/each}
    </div>
  </div>

  <!-- ── 폰 프레임 ── -->
  <div class="phone-frame relative w-[375px] rounded-[50px] overflow-hidden"
       style="height: 812px; background: #0f0f0f;">

    <!-- 상단 노치 영역 -->
    <div class="absolute top-0 left-0 right-0 z-10 flex items-center justify-between px-8 pt-4 pb-2"
         style="background: linear-gradient(to bottom, #0f0f0f 70%, transparent);">
      <span class="text-white text-sm font-semibold tracking-tight">10:26</span>
      <div class="flex items-center gap-1.5">
        <!-- Signal -->
        <svg width="17" height="11" viewBox="0 0 17 11" fill="none">
          <rect x="0" y="7" width="3" height="4" rx="1" fill="white" fill-opacity="0.9"/>
          <rect x="4.5" y="4.5" width="3" height="6.5" rx="1" fill="white" fill-opacity="0.9"/>
          <rect x="9" y="2" width="3" height="9" rx="1" fill="white" fill-opacity="0.9"/>
          <rect x="13.5" y="0" width="3" height="11" rx="1" fill="white" fill-opacity="0.3"/>
        </svg>
        <!-- WiFi -->
        <svg width="15" height="11" viewBox="0 0 15 11" fill="none">
          <circle cx="7.5" cy="9.5" r="1.5" fill="white" fill-opacity="0.9"/>
          <path d="M4 7C5.1 5.9 6.2 5.3 7.5 5.3s2.4.6 3.5 1.7" stroke="white" stroke-opacity="0.9" stroke-width="1.4" stroke-linecap="round" fill="none"/>
          <path d="M1.5 4C3.2 2.3 5.2 1.4 7.5 1.4s4.3.9 6 2.6" stroke="white" stroke-opacity="0.9" stroke-width="1.4" stroke-linecap="round" fill="none"/>
        </svg>
        <!-- Battery -->
        <svg width="24" height="12" viewBox="0 0 24 12" fill="none">
          <rect x="0.5" y="0.5" width="20" height="11" rx="3" stroke="white" stroke-opacity="0.35"/>
          <rect x="1.5" y="1.5" width="17" height="9" rx="2" fill="white" fill-opacity="0.9"/>
          <path d="M22 4v4a2 2 0 000-4z" fill="white" fill-opacity="0.4"/>
        </svg>
      </div>
    </div>

    <!-- ── 스크롤 영역 ── -->
    <div class="absolute inset-0 overflow-y-auto pb-28 pt-12" style="scrollbar-width:none;">

      <!-- ════ SCREEN 1: TRIPS HOME ════ -->
      {#if currentScreen === 1}
        <!-- 헤더 -->
        <div class="flex items-center justify-between px-6 pt-5 pb-5">
          <div>
            <p class="text-white/40 text-xs tracking-widest uppercase font-medium mb-0.5">TripHelper</p>
            <h1 class="text-white text-[30px] font-bold tracking-tight leading-none">여행</h1>
          </div>
          <button aria-label="알림" class="relative w-10 h-10 rounded-full flex items-center justify-center"
                  style="background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);">
            <svg class="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
            </svg>
            <span class="absolute top-1.5 right-1.5 w-2 h-2 bg-[#20b2aa] rounded-full"></span>
          </button>
        </div>

        <!-- 최근 여행 카드 -->
        <div class="mx-4 mb-5 rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
          <div class="flex items-center justify-between mb-4">
            <span class="text-white font-semibold text-[15px]">최근 계획한 여행</span>
            <button class="text-[#20b2aa] text-xs font-medium">전체보기</button>
          </div>
          <div class="space-y-0">
            {#each recentTrips as trip, i}
              <button
                onclick={() => currentScreen = 2}
                class="w-full flex items-center justify-between py-3.5 text-left group
                       {i < recentTrips.length - 1 ? 'border-b' : ''}"
                style="border-color: rgba(255,255,255,0.06);"
              >
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
                       style="background: rgba(32,178,170,0.15);">
                    <svg class="w-4 h-4 text-[#20b2aa]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"/>
                    </svg>
                  </div>
                  <div>
                    <p class="text-white text-sm font-medium leading-snug">{trip.name}</p>
                    <p class="text-white/35 text-[11px] mt-0.5">{trip.startDate} — {trip.endDate}</p>
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <span class="text-white/30 text-[11px]">{trip.distance}</span>
                  <svg class="w-4 h-4 text-white/20 group-hover:text-white/40 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                </div>
              </button>
            {/each}
          </div>
        </div>

        <!-- 인기 여행지 -->
        <div class="px-4">
          <div class="flex items-center justify-between mb-3">
            <span class="text-white font-semibold text-[15px]">인기 여행지</span>
            <button class="text-[#20b2aa] text-xs font-medium">전체보기</button>
          </div>
          <div class="space-y-3">
            {#each popularDestinations as dest}
              <button
                onclick={() => currentScreen = 2}
                class="w-full rounded-3xl overflow-hidden relative group"
                style="height: 180px;"
              >
                <img src={dest.image} alt={dest.name}
                     class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
                <!-- 다크 오버레이 그라디언트 -->
                <div class="absolute inset-0"
                     style="background: linear-gradient(180deg, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.65) 100%)"></div>
                <!-- 글래스 배지 (Perplexity 스타일) -->
                <div class="absolute top-3 right-3 flex items-center gap-1 px-2.5 py-1 rounded-full"
                     style="background: rgba(0,0,0,0.45); backdrop-filter: blur(12px); border: 1px solid rgba(255,255,255,0.15);">
                  <span class="text-yellow-400 text-[11px]">★</span>
                  <span class="text-white text-[11px] font-semibold">{dest.rating}</span>
                </div>
                <div class="absolute bottom-3 left-4 text-left">
                  <p class="text-white font-bold text-base leading-tight">{dest.name}</p>
                  <p class="text-white/60 text-xs mt-0.5">{dest.trips}개 여행 플랜</p>
                </div>
              </button>
            {/each}
          </div>
        </div>

      <!-- ════ SCREEN 2: TRIP BUILDER INPUT ════ -->
      {:else if currentScreen === 2}
        <div class="px-6 pt-5 pb-4">
          <p class="text-white/40 text-xs tracking-widest uppercase font-medium mb-1">AI 어시스턴트</p>
          <h1 class="text-white text-[30px] font-bold tracking-tight leading-none">여행 빌더</h1>
        </div>

        <div class="px-4 space-y-3">
          <!-- 텍스트 입력 -->
          <div class="rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            <p class="text-white/60 text-xs font-medium tracking-wide uppercase mb-2.5">어떤 여행을 원하세요?</p>
            <textarea
              bind:value={tripInput}
              rows="4"
              class="w-full bg-transparent text-sm text-white/80 resize-none outline-none leading-relaxed placeholder-white/20"
              placeholder="예: 가족과 함께 떠나는 7일 남해안 드라이브, 맛집과 해변을 함께..."
            ></textarea>
          </div>

          <!-- 프리셋 태그 -->
          <div class="rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            <p class="text-white/40 text-[11px] font-medium uppercase tracking-widest mb-3">빠른 선택</p>
            <div class="flex flex-wrap gap-2">
              {#each presetTags as tag}
                <button
                  onclick={() => toggleTag(tag)}
                  class="px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200
                    {selectedTags.includes(tag)
                      ? 'text-[#0f0f0f] font-semibold'
                      : 'text-white/50 hover:text-white/70'}"
                  style="{selectedTags.includes(tag)
                    ? 'background: #20b2aa; border: 1px solid #20b2aa;'
                    : 'background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);'}"
                >
                  {#if selectedTags.includes(tag)}<span class="mr-1 text-[10px]">✓</span>{/if}{tag}
                </button>
              {/each}
            </div>
          </div>

          <!-- 예산 슬라이더 -->
          <div class="rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            <div class="flex items-center justify-between mb-3">
              <p class="text-white/60 text-xs font-medium uppercase tracking-wide">예산 (1인 기준)</p>
              <span class="text-[#20b2aa] text-sm font-bold">{formatBudget(budget)}</span>
            </div>
            <input type="range" bind:value={budget} min="500" max="5000" step="100"
              class="range-dark w-full h-1 appearance-none rounded-full outline-none cursor-pointer"
              style="background: linear-gradient(to right, #20b2aa 0%, #20b2aa {((budget-500)/4500)*100}%, rgba(255,255,255,0.1) {((budget-500)/4500)*100}%, rgba(255,255,255,0.1) 100%)"
            />
            <div class="flex justify-between mt-2">
              <span class="text-white/25 text-[10px]">50만원</span>
              <span class="text-white/25 text-[10px]">500만원+</span>
            </div>
          </div>

          <!-- 여행 기간 -->
          <div class="rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            <p class="text-white/60 text-xs font-medium uppercase tracking-wide mb-3">여행 기간</p>
            <div class="flex items-center gap-3">
              <button onclick={() => duration = Math.max(1, duration - 1)}
                class="w-10 h-10 rounded-2xl flex items-center justify-center text-white/60 text-xl font-light transition-colors hover:text-white"
                style="background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);">−</button>
              <div class="flex-1 text-center">
                <span class="text-white text-2xl font-bold tabular-nums">{duration}</span>
                <span class="text-white/40 text-sm ml-1.5">일</span>
              </div>
              <button onclick={() => duration = Math.min(30, duration + 1)}
                class="w-10 h-10 rounded-2xl flex items-center justify-center text-white/60 text-xl font-light transition-colors hover:text-white"
                style="background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);">+</button>
            </div>
          </div>

          <!-- 생성 버튼 -->
          <button
            onclick={generateItinerary}
            disabled={generating}
            class="w-full py-4 rounded-2xl font-bold text-[15px] flex items-center justify-center gap-2.5 transition-all active:scale-[0.97]"
            style="{generating
              ? 'background: rgba(32,178,170,0.4); cursor:wait;'
              : 'background: linear-gradient(135deg, #20b2aa, #17a89a);'} color: #0f0f0f;"
          >
            {#if generating}
              <svg class="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
              </svg>
              AI가 일정을 생성 중...
            {:else}
              <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L13.09 8.26L19 6L15.45 11.27L22 12L15.45 12.73L19 18L13.09 15.74L12 22L10.91 15.74L5 18L8.55 12.73L2 12L8.55 11.27L5 6L10.91 8.26L12 2Z"/>
              </svg>
              ✦ 일정 생성하기
            {/if}
          </button>
        </div>

      <!-- ════ SCREEN 3: RESULT ════ -->
      {:else}
        <div class="px-6 pt-5 pb-4">
          <p class="text-white/40 text-xs tracking-widest uppercase font-medium mb-1">생성 완료</p>
          <h1 class="text-white text-[26px] font-bold tracking-tight leading-tight">
            남해안<br/>드라이브 어드벤처
          </h1>
          <p class="text-white/35 text-xs mt-1.5">{duration}일 · {formatBudget(budget)} 예산</p>
        </div>

        <div class="px-4 space-y-3">
          <!-- 지도 카드 -->
          <div class="rounded-3xl overflow-hidden relative" style="height: 160px;">
            <img src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=600&q=80"
                 alt="map" class="w-full h-full object-cover opacity-50"/>
            <div class="absolute inset-0" style="background: linear-gradient(135deg, rgba(15,15,15,0.6), rgba(32,178,170,0.1))"></div>
            <!-- SVG 경로 -->
            <svg class="absolute inset-0 w-full h-full" viewBox="0 0 340 160" fill="none">
              <path d="M55 28 Q95 55 138 78 Q198 105 248 125 Q278 136 312 145"
                    stroke="#20b2aa" stroke-width="2" stroke-dasharray="5 4" fill="none" opacity="0.8"/>
              {#each [[55,28],[138,78],[248,125],[312,145]] as [x,y]}
                <circle cx={x} cy={y} r="7" fill="rgba(15,15,15,0.8)" stroke="#20b2aa" stroke-width="1.5"/>
                <circle cx={x} cy={y} r="3" fill="#20b2aa"/>
              {/each}
            </svg>
            <div class="absolute top-3 left-4 text-xs font-bold text-white px-2 py-0.5 rounded-md"
                 style="background:rgba(0,0,0,0.5); backdrop-filter:blur(8px);">서울</div>
            <div class="absolute bottom-4 right-5 text-xs font-bold text-white px-2 py-0.5 rounded-md"
                 style="background:rgba(0,0,0,0.5); backdrop-filter:blur(8px);">제주</div>
            <!-- 재생성 버튼 -->
            <button aria-label="일정 재생성" class="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center"
                    style="background:rgba(255,255,255,0.1); backdrop-filter:blur(8px); border:1px solid rgba(255,255,255,0.15);">
              <svg class="w-3.5 h-3.5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
            </button>
          </div>

          <!-- 경로 하이라이트 -->
          <div class="rounded-3xl p-4" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            <p class="text-white/60 text-[11px] font-medium uppercase tracking-widest mb-3">경로 하이라이트</p>
            <div class="space-y-2.5">
              {#each routeHighlights as route}
                <div class="flex items-center gap-2">
                  <div class="flex items-center gap-1.5 flex-1">
                    <div class="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                         style="background: rgba(32,178,170,0.2);">
                      <div class="w-1.5 h-1.5 rounded-full bg-[#20b2aa]"></div>
                    </div>
                    <span class="text-white/80 text-xs font-medium">{route.from}</span>
                  </div>
                  <div class="flex-1 border-t border-dashed border-white/10"></div>
                  <svg class="w-3 h-3 text-white/20 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                  </svg>
                  <div class="flex items-center gap-1.5 flex-1 justify-end">
                    <span class="text-white/80 text-xs font-medium">{route.to}</span>
                    <div class="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                         style="background: rgba(32,178,170,0.2);">
                      <div class="w-1.5 h-1.5 rounded-full bg-[#20b2aa]"></div>
                    </div>
                  </div>
                </div>
              {/each}
            </div>
          </div>

          <!-- Day 아코디언 -->
          <div class="rounded-3xl overflow-hidden" style="background:#1a1a1a; border:1px solid rgba(255,255,255,0.07);">
            {#each itineraryDays as day, i}
              <div class="{i < itineraryDays.length - 1 ? 'border-b' : ''}"
                   style="border-color: rgba(255,255,255,0.05);">
                <button
                  onclick={() => toggleDay(day.day)}
                  class="w-full flex items-center justify-between px-4 py-3.5 text-left transition-colors hover:bg-white/[0.03]"
                >
                  <div class="flex items-center gap-3">
                    <span class="text-[#20b2aa] text-xs font-black tabular-nums w-8">D{day.day}</span>
                    <div>
                      <p class="text-white/90 text-sm font-medium leading-snug">{day.title}</p>
                      {#if !expandedDays[day.day]}
                        <p class="text-white/30 text-[11px] mt-0.5">{day.places.length}개 장소</p>
                      {/if}
                    </div>
                  </div>
                  <svg class="w-4 h-4 text-white/25 flex-shrink-0 transition-transform duration-200
                               {expandedDays[day.day] ? 'rotate-180' : ''}"
                       fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                  </svg>
                </button>
                {#if expandedDays[day.day]}
                  <div class="px-4 pb-4 space-y-2" style="border-top: 1px solid rgba(255,255,255,0.05);">
                    {#each day.places as place, j}
                      <div class="flex items-center gap-3 pt-2.5">
                        <div class="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                             style="background: rgba(32,178,170,0.12); border: 1px solid rgba(32,178,170,0.25);">
                          <span class="text-[#20b2aa] text-[9px] font-black">{j+1}</span>
                        </div>
                        <span class="text-white/55 text-xs">{place}</span>
                      </div>
                    {/each}
                  </div>
                {/if}
              </div>
            {/each}
          </div>

          <!-- 액션 버튼 -->
          <div class="flex gap-3 pb-2">
            <button
              onclick={() => currentScreen = 2}
              class="flex-1 py-4 rounded-2xl text-sm font-semibold text-white/50 hover:text-white/70 transition-colors"
              style="background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);"
            >다시 생성</button>
            <button
              class="flex-1 py-4 rounded-2xl text-sm font-bold transition-all active:scale-[0.97]"
              style="background: linear-gradient(135deg, #20b2aa, #17a89a); color: #0f0f0f;"
            >저장하기</button>
          </div>
        </div>
      {/if}
    </div>

    <!-- ── Perplexity 스타일 Pill 탭바 ── -->
    <div class="pill-nav absolute bottom-5 left-0 right-0 flex justify-center pointer-events-none">
      <div class="pill-glass flex items-center gap-1 px-3 py-2 pointer-events-auto">
        {#each [
          { s: 1, icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
          { s: 2, icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z' },
          { s: 3, icon: 'M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7' },
          { s: 0, icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
        ] as item}
          <button
            onclick={() => { if (item.s > 0) currentScreen = item.s; }}
            class="relative w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-200 group"
            style="{currentScreen === item.s ? 'background: rgba(255,255,255,0.12);' : ''}"
          >
            <svg
              class="w-[22px] h-[22px] transition-all duration-200"
              style="color: {currentScreen === item.s ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.3)'};"
              fill="none" stroke="currentColor" viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="{currentScreen === item.s ? 2.2 : 1.8}" d={item.icon}/>
            </svg>
            <!-- 활성 인디케이터 dot -->
            {#if currentScreen === item.s}
              <span class="absolute bottom-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-[#20b2aa]"></span>
            {/if}
          </button>
        {/each}
      </div>
    </div>
  </div>

  <!-- 외부 네비 -->
  <div class="mt-7 flex items-center gap-3">
    {#if currentScreen > 1}
      <button onclick={() => currentScreen--}
        class="flex items-center gap-2 px-4 py-2 rounded-full text-sm text-white/50 hover:text-white/70 transition-colors"
        style="background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1);">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
        </svg>
        이전
      </button>
    {/if}
    {#if currentScreen < 3}
      <button
        onclick={() => currentScreen === 2 ? generateItinerary() : currentScreen++}
        class="flex items-center gap-2 px-5 py-2 rounded-full text-sm font-semibold transition-all"
        style="background: linear-gradient(135deg, #20b2aa, #17a89a); color: #0f0f0f;">
        {currentScreen === 2 ? '✦ 일정 생성' : '다음 화면'}
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"/>
        </svg>
      </button>
    {:else}
      <span class="text-white/25 text-xs">데모 완료 ✦</span>
    {/if}
  </div>

  <a href="/trips" class="mt-3 text-white/20 text-xs hover:text-white/40 transition-colors">
    실제 앱으로 돌아가기 →
  </a>
</div>

<style>
  .phone-frame {
    box-shadow:
      0 0 0 1px rgba(255,255,255,0.08),
      0 30px 80px rgba(0,0,0,0.7),
      0 10px 30px rgba(0,0,0,0.5);
  }

  /* Perplexity 스타일 다크 글라스 pill */
  .pill-glass {
    background: rgba(22, 22, 24, 0.82);
    backdrop-filter: blur(28px) saturate(160%);
    -webkit-backdrop-filter: blur(28px) saturate(160%);
    border: 1px solid rgba(255, 255, 255, 0.09);
    border-radius: 26px;
    box-shadow:
      0 0 0 0.5px rgba(255,255,255,0.05) inset,
      0 12px 40px rgba(0, 0, 0, 0.55),
      0 4px 12px rgba(0, 0, 0, 0.35);
    /* 상단 specular highlight (liquid glass 느낌) */
    position: relative;
  }

  .pill-glass::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 26px;
    background: linear-gradient(
      180deg,
      rgba(255,255,255,0.06) 0%,
      rgba(255,255,255,0.01) 40%,
      transparent 100%
    );
    pointer-events: none;
  }

  /* 다크 슬라이더 thumb */
  .range-dark::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #20b2aa;
    box-shadow: 0 0 0 3px rgba(32,178,170,0.25), 0 2px 8px rgba(0,0,0,0.4);
    cursor: pointer;
  }
  .range-dark::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #20b2aa;
    border: none;
    box-shadow: 0 0 0 3px rgba(32,178,170,0.25), 0 2px 8px rgba(0,0,0,0.4);
    cursor: pointer;
  }

  /* 스크롤바 숨김 */
  div::-webkit-scrollbar { display: none; }
</style>
